import React from "react";
import { Tick } from "@wuilt/ui-components";
import classnames from "classnames";
import classes from "./DropDown.module.scss";

interface DropDownProps {
  direction: "up" | "down";
  children: React.ReactNode;
  className?: string;
  id: string;
  visible: boolean;
}

const DropDown = (props: DropDownProps) => {
  const { visible, children, direction } = props;
  const dropDirectionUp = direction === "up";
  if (!visible) return null;
  const contentContainerClassName = classnames({
    [classes.contentContainer]: true,
    [classes.shown]: visible,
    [classes.up]: dropDirectionUp,
    [classes.down]: !dropDirectionUp,
  });
  return (
    <div className={classnames(classes.wrapper)}>
      <div className={contentContainerClassName}>
        <div className={classes.innerContentContainer}>{children}</div>
      </div>
    </div>
  );
};

interface DropDownItemProps {
  selected: boolean;
  children: React.ReactNode;
}

DropDown.Item = ({ selected, children }: DropDownItemProps) => (
  <div
    className={classnames({
      [classes.option]: true,
      [classes["--selected"]]: selected,
    })}
  >
    {selected ? (
      <div className={classes.optionSelectedIndicator}>
        <Tick size="10px" />
      </div>
    ) : (
      <div className={classes.optionNotSelectedIndicator} />
    )}
    {children}
  </div>
);
export default DropDown;
